import { useState } from "react";
import imageCompression from "browser-image-compression";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

async function handleFile(file, setter) {
  if (!file) return;
  const ext = file.name.split(".").pop();
  if (ext !== "jpg" && ext !== "jpeg" && ext !== "png") {
    return false;
  }
  const options = { maxSizeMB: 1, maxWidthOrHeight: 600 };
  const compressed = await imageCompression(file, options);
  const reader = new FileReader();
  reader.readAsDataURL(compressed);
  reader.onload = () => setter(reader.result);
  return true;
}

export default function StepContactAndId({ data, update }) {
  const { candidateMail, confirmMail, showBox, poa, poId } = data;
  const [poiFileName, setPoiFileName] = useState("");
  const [poaFileName, setPoaFileName] = useState("");
  const [poiError, setPoiError] = useState(false);
  const [poaError, setPoaError] = useState(false);

  const flashError = (setError) => {
    setError(true);
    setTimeout(() => setError(false), 1500);
  };

  const handlePoId = async (e) => {
    const file = e.target.files?.[0];
    const ok = await handleFile(file, (v) => update("poId", v));
    if (ok && file) setPoiFileName(file.name);
    if (!ok && file) {
      flashError(setPoiError);
      setPoiFileName("");
      e.target.value = "";
    }
  };

  const handlePoa = async (e) => {
    const file = e.target.files?.[0];
    const ok = await handleFile(file, (v) => update("poa", v));
    if (ok && file) setPoaFileName(file.name);
    if (!ok && file) {
      flashError(setPoaError);
      setPoaFileName("");
      e.target.value = "";
    }
  };

  return (
    <Box component="section" className="nsp_step">
      <TextField
        type="email"
        id="candidateEmail"
        label="Email"
        required
        placeholder="Enter email"
        value={candidateMail}
        onChange={(e) => update("candidateMail", e.target.value)}
        inputProps={{ maxLength: 75 }}
        sx={{ mb: 2 }}
      />
      <TextField
        type="email"
        id="confirmEmail"
        label="Confirm email"
        required
        placeholder="Confirm email"
        value={confirmMail}
        onChange={(e) => update("confirmMail", e.target.value)}
        inputProps={{ maxLength: 75 }}
        sx={{ mb: 3 }}
      />

      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        {showBox ? "Proof of ID - Passport" : "Proof of ID"}{" "}
        {!data.trialPoiHeld && (
          <Box component="span" sx={{ color: "error.main", fontWeight: 800 }}>
            *
          </Box>
        )}
      </Typography>
      {data.trialPoiHeld ? (
        <Typography sx={{ mb: 1 }}>
          Proof of ID was provided with your trial shift. You can upload a new
          image if you want to replace it.
        </Typography>
      ) : null}
      {poiError && (
        <Alert severity="error" sx={{ mb: 1 }}>
          You must upload an image (jpg or png)
        </Alert>
      )}
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 3 }}>
        <Button
          variant="outlined"
          component="label"
          startIcon={<CloudUploadIcon />}
        >
          Upload file
          <input
            type="file"
            accept="image/*"
            id="poi_input"
            hidden
            onChange={handlePoId}
          />
        </Button>
        <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
          {poiFileName || (poId ? "Image attached" : "No file selected")}
        </Typography>
      </Stack>

      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Proof of Address{" "}
        <Box component="span" sx={{ color: "error.main", fontWeight: 800 }}>
          *
        </Box>
      </Typography>
      {poaError && (
        <Alert severity="error" sx={{ mb: 1 }}>
          You must upload an image (jpg or png)
        </Alert>
      )}
      <Stack direction="row" spacing={2} alignItems="center">
        <Button
          variant="outlined"
          component="label"
          startIcon={<CloudUploadIcon />}
        >
          Upload file
          <input
            type="file"
            accept="image/*"
            id="poa_input"
            hidden
            onChange={handlePoa}
          />
        </Button>
        <Typography variant="body2" sx={{ wordBreak: "break-all" }}>
          {poaFileName || (poa ? "Image attached" : "No file selected")}
        </Typography>
      </Stack>
    </Box>
  );
}
